(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EodbPublicDashboardController', EodbPublicDashboardController);

    EodbPublicDashboardController.$inject = ['$scope','$filter', 'Principal', '$state', 'EodbPublicDashboardByElastic', 'District', 'EodbPublicDashboardByFilter'];

    function EodbPublicDashboardController ($scope, $filter, Principal, $state, EodbPublicDashboardByElastic, District, EodbPublicDashboardByFilter) {
        var vm = this;
        vm.account = null;
        vm.districts = [];
        vm.departments = [];
        vm.filter = {};
        vm.hideClear = false;
        $scope.CurrentDate = new Date();

        // Time Period column. The rows this dashboard reads are built with the 01-April-2018
        // window (see /api/updateNewDashboardDataFromStats), so the period runs from that date up
        // to the current month.
        vm.dataStartDate = new Date(2018, 3, 1);
        vm.timePeriod = $filter('date')(vm.dataStartDate, 'MMM yyyy') + ' - ' + $filter('date')($scope.CurrentDate, 'MMM yyyy');

        loadAll();
        function loadAll() {
            Principal.identity().then(function(account) {
                vm.account = account;
            });

            District.query(function(result) {
                vm.districts = result;
                vm.searchQuery = null;
            });

            EodbPublicDashboardByElastic.query(function(result) {
                vm.deptservicedashboard = result;
                vm.totalappliedservices = 0;
                vm.totalpendingservices = 0;
                vm.totalcompletedservices = 0;
                vm.totalrejectedservices = 0;
                for (var i = 0; i < vm.deptservicedashboard.length; i++) {
                    vm.totalappliedservices = vm.totalappliedservices + parseInt(vm.deptservicedashboard[i].applied);
                    vm.totalpendingservices = vm.totalpendingservices + parseInt(vm.deptservicedashboard[i].pending_total);
                    vm.totalcompletedservices = vm.totalcompletedservices + parseInt(vm.deptservicedashboard[i].cleared);
                    vm.totalrejectedservices = vm.totalrejectedservices + parseInt(vm.deptservicedashboard[i].rejected);
                }
                vm.searchQuery = null;
                vm.departments = [];

                angular.forEach(vm.deptservicedashboard, function(value, key){
                    if (vm.departments.indexOf(value.department_name) === -1) {
                        if (value.department_name != "Communication and Connectivity Permissions") {
                            vm.departments.push(value.department_name);
                        }
                    }
                });
            });
        }

        vm.FilterWiseDat = function () {
            EodbPublicDashboardByFilter.query(vm.filter, function (result) {
                vm.hideClear = true;
                vm.deptservicedashboard = result;
            })
        };

        vm.clearFilter = function () {
            vm.filter = {};
            vm.hideClear = false;
            loadAll();
        }
    }
})();
